export enum LanguagesText {
  LV = 'Latviešu',
  EN = 'English',
}
